import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Edit from '@material-ui/icons/Edit'
import PriorityHigh from '@material-ui/icons/PriorityHigh'
import {Tooltip} from "@material-ui/core";
import {confirmAlert} from "react-confirm-alert";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import {applyCollectionRowHighlight, applyHighlightFilter, getCollectionHighlightTrProps, getHighlightPkeyFromLocation, syncCollectionFetchPage} from "utilities/avCenterHighlight";

const DISMISSAL_REASONS = [
	{ value: 'paid_elsewhere', label: 'Paid elsewhere / confirmed active' },
	{ value: 'not_in_stripe_legacy', label: 'Legacy - not in Stripe' },
	{ value: 'confirmed_removed', label: 'Confirmed removed' },
	{ value: 'false_positive', label: 'False positive' },
	{ value: 'other', label: 'Other' },
];

export default class InactiveAvSubscriptions extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Inactive_Av_Subscriptions._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
		this.state.resolveModal = false;
		this.state.resolveRow = null;
		this.state.dismissalReason = '';
		this.state.resolveNotes = '';
		this.state.actionError = null;
		this.state.resolvedFilter = 'unresolved';
		this.state.highlightRow = getHighlightPkeyFromLocation(props.history);
		this.rowRefs = {};
	}

	componentDidUpdate(prevProps) {
		if (prevProps.history?.location?.hash !== this.props.history?.location?.hash) {
			const highlightRow = getHighlightPkeyFromLocation(this.props.history);
			this.setState({highlightRow}, () => this.fetchData());
		}
	}

	fetchData = async (state) => {
		syncCollectionFetchPage(this, state);
		if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		delete this.state.filter.resolved;
		this.state.filter.resolved_view = this.state.resolvedFilter;
		const highlightPkey = applyHighlightFilter(this, this.state.filter);
		this.model.filter = this.state.filter;
		this.setState({loading: true, highlightRow: highlightPkey || this.state.highlightRow});
		window.setTimeout(async () => {
			await this.fetchDataActual(state);
			applyCollectionRowHighlight(this);
		}, 100);
	}

	markResolved = async (pkey, dismissalReason, notes) => {
		this.setState({ actionError: null });
		try {
			let model = new API.BuildClass(Types.Inactive_Av_Subscriptions._name, API.RequestType.UPDATE);
			model.object.pkey = pkey;
			model.object.dismissal_reason = dismissalReason || null;
			if (notes !== undefined) {
				model.object.notes = notes;
			}
			await model.submit(null, 'POST_MARK_RESOLVED');
			await this.fetchData();
		} catch (err) {
			this.setState({ actionError: err?.message || 'Could not resolve row' });
		}
	}

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal]})
	}

	renderDismissalReason = (value) => {
		const match = DISMISSAL_REASONS.find(r => r.value === value);
		return match?.label || value || '-';
	}

	formatProductName = (row) => {
		const stripeCharge = row?.stripe_charges;
		if (!stripeCharge) {
			return '-';
		}
		return stripeCharge.av_keys?.product_name
			|| stripeCharge.stripe_products?.name
			|| '-';
	}

	render() {
		const {data, pages, limit, loading, resolvedFilter, highlightRow} = this.state;

		const columns = [
			{
				Header: "Customer",
				id: "customer_name",
				Cell: (props) => {
					const stripeCharge = props.original?.stripe_charges;
					const customerPkey = stripeCharge?.customer;
					const customerName = stripeCharge?.customers?.name;
					if (!customerPkey || !customerName) {
						return customerName || '-';
					}
					return (
						<span>
							<Link to={`/customers/${customerPkey}#av-center`}>
								{customerName}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "Product",
				id: 'product_name',
				accessor: obj => this.formatProductName(obj),
			},
			{
				Header: "Stripe Status",
				id: 'stripe_status',
				accessor: obj => {
					const status = obj.stripe_status || 'N/A';
					const cancel = obj.cancel_at_period_end ? ' (cancel at period end)' : '';
					return `${status}${cancel}`;
				},
			},
			{
				Header: "Modified At",
				id: 'modified',
				accessor: obj => obj.modified ? moment(obj.modified).local().format('MM/DD/YYYY h:mm A') : '',
			},
			{
				Header: "Modified By",
				id: 'modifier',
				accessor: obj => obj.modifier ? (obj.users.name_first + " " + obj.users.name_last) : obj.modified ? 'Admin' : '',
			},
			{
				Header: "Message",
				id: 'message',
				accessor: obj => obj.message,
			},
			{
				Header: "Dismissal Reason",
				id: 'dismissal_reason',
				accessor: obj => this.renderDismissalReason(obj.dismissal_reason),
				show: resolvedFilter === 'resolved' || resolvedFilter === 'all',
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				show: resolvedFilter === 'unresolved',
				Cell: props => {
					return (
						<Tooltip title={"Mark as resolved."}>
							<Button color={'info'} size={'sm'} onClick={() => {
								this.setState({
									resolveModal: true,
									resolveRow: props.original,
									dismissalReason: props.original.dismissal_reason || '',
									resolveNotes: props.original.notes ?? '',
								});
							}}>
								<PriorityHigh fontSize='small'/>
							</Button>
						</Tooltip>
					);
				}
			},
			{
				Header: "Notes",
				id: 'notes',
				style: { whiteSpace: "normal", wordBreak: "break-word" },
				width: 500,
				accessor: obj => obj.notes,
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				Cell: props => {
					return (
						<Tooltip title={"Add to notes."}>
							<Button
								color="green-meadow"
								size={"sm"}
								onClick={() => {
									this.setState({ notesModal: true, note: props.original, notes: props.original.notes ?? "" });
								}}
							>
								<Edit fontSize="small" />
							</Button>
						</Tooltip>
					);
				}
			},
		]

		return (
			<Card>
				<Modal isOpen={this.state.resolveModal} toggle={() => this.handleToggleModal('resolveModal')} size={"lg"}>
					<ModalHeader>Resolve Renewal Removal</ModalHeader>
					<ModalBody>
						<FormControl fullWidth variant="outlined" margin="normal">
							<InputLabel shrink htmlFor="resolve-dismissal-reason">Dismissal reason (optional)</InputLabel>
							<Select
								native
								value={this.state.dismissalReason}
								onChange={(event) => this.setState({ dismissalReason: event.currentTarget.value })}
								inputProps={{ id: 'resolve-dismissal-reason' }}
							>
								<option value="">-</option>
								{DISMISSAL_REASONS.map((opt) => (
									<option key={opt.value} value={opt.value}>{opt.label}</option>
								))}
							</Select>
						</FormControl>
						{this.state.dismissalReason && (
							<p style={{ marginTop: 8, marginBottom: 0 }}>
								<strong>Selected:</strong> {this.renderDismissalReason(this.state.dismissalReason)}
							</p>
						)}
						<TextField
							fullWidth
							margin="normal"
							label="Notes"
							value={this.state.resolveNotes}
							onChange={(event) => this.setState({ resolveNotes: event.currentTarget.value })}
							variant="outlined"
							multiline
							rows={5}
						/>
					</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={async () => {
							await this.markResolved(this.state.resolveRow.pkey, this.state.dismissalReason, this.state.resolveNotes);
							this.setState({ resolveModal: false, resolveRow: null, dismissalReason: '', resolveNotes: '' });
						}}>Resolve</Button>
						<Button onClick={() => this.setState({ resolveModal: false })}>Cancel</Button>
					</ModalFooter>
				</Modal>
				<Modal
					isOpen={this.state.notesModal}
					toggle={() => this.handleToggleModal('notesModal')}
					size={"lg"}
				>
					<ModalHeader>Add to Notes</ModalHeader>
					<ModalBody>
						<TextField
							fullWidth
							label="Notes"
							value={this.state.notes}
							onChange={(event) => this.setState({ notes: event.currentTarget.value })}
							variant="outlined"
							multiline
							rows={5}
						/>
					</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={async () => {
							let model = new API.BuildClass(Types.Inactive_Av_Subscriptions._name, API.RequestType.UPDATE);
							model.object = this.state.note;
							model.object.notes = this.state.notes;
							await model.submit(null, "POST");
							await this.fetchData();
							this.setState({ notes: "", notesModal: false });
						}}>Save</Button>
						<Button onClick={() => this.setState({ notes: "", notesModal: false })}>Cancel</Button>
					</ModalFooter>
				</Modal>
				<CardContent>
					{this.state.actionError && (
						<div className="alert alert-danger" role="alert">{this.state.actionError}</div>
					)}
					<div className="table-bar">
						<div className="d-flex align-items-center">
							<TextField
								select
								label="Status"
								value={resolvedFilter}
								onChange={(e) => this.setState({ resolvedFilter: e.target.value }, () => this.fetchData())}
								margin="dense"
								style={{ minWidth: 180, marginRight: 16 }}
							>
								<MenuItem value="unresolved">Unresolved</MenuItem>
								<MenuItem value="resolved">Resolved</MenuItem>
								<MenuItem value="all">All</MenuItem>
							</TextField>
							{this.renderSearch('AV Subscriptions')}
							{this.renderHeaderRight('AV Subscriptions', columns)}
						</div>
					</div>
					<ReactTable
						key={`${this.state.key}-${resolvedFilter}`}
						columns={columns}
						manual
						data={data}
						pages={pages}
						loading={loading}
						loadingText="Requesting Data"
						onFetchData={this.fetchData}
						defaultSorted={[{ id: this.model.sort, desc: this.model.order === 'desc' }]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						onPageChange={this.onPageChange}
						page={this.state.page}
						pageSize={limit}
						getTrProps={getCollectionHighlightTrProps(highlightRow, this.rowRefs)}
					/>
					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
